import { Button } from '../../../../../../components/button/button';
import { Divider } from '../../../../../../components/divider/divider';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { Select } from '../../../../../../components/select/select';
import { TextArea } from '../../../../../../components/textarea/textarea';
import { MultiSelect } from '../../../../../../features/multi-select/multi-select';
import s from './tasks-create-task-modal.module.css';
import { useTasksCreateTaskModal } from './use-tasks-create-task-modal';

export const TasksCreateTaskModal = (props: ModalProps) => {
  const {
    t,
    task,
    isLoadingFetch,
    handleCreate,
    setTask,
    groupedStaffsByTags,
    executors,
    branches,
    selectedBranch,
  } = useTasksCreateTaskModal(props);

  return (
    <Modal {...props} className={s.feature} title={t('Создание задачи')}>
      <div className={s.inputs}>
        <TextArea
          name="name"
          value={task.title}
          onChange={(e) => setTask({ ...task, title: e.currentTarget.value })}
          placeholder={t('Опишите задачу')}
          data-testid="name-input"
          maxLength={200}
          style={{
            height: 160,
          }}
        />
        <Select
          name="branch"
          options={branches}
          value={selectedBranch}
          onSelect={(e) =>
            setTask({ ...task, place_id: Number(e.id), staff_ids: [], staff_id: undefined })
          }
          placeholder={t('Филиал')}
          data-testid="branch-input"
          withSearch
        />
        <MultiSelect
          name="executor"
          value={executors}
          onSelect={(e) => setTask({ ...task, staff_ids: e.map((item) => Number(item.id)) })}
          options={groupedStaffsByTags}
          placeholder={t('Ответственные')}
          data-testid="responsibles-input"
        />
      </div>

      <Divider />

      <div className={s.controls}>
        <Button
          variant="secondary"
          onClick={props.onClose}
          disabled={isLoadingFetch}
          data-testid="back-button"
        >
          {t('Назад')}
        </Button>
        <Button
          variant="primary"
          onClick={handleCreate}
          disabled={isLoadingFetch}
          data-testid="submit-button"
        >
          {t('Создать')}
        </Button>
      </div>
    </Modal>
  );
};
